import { AdvancedMarker, APIProvider, Map } from "@vis.gl/react-google-maps";
import React from "react";

import AppConstants from "../../classes/constants";
import rsStyles from "../recent-settlement.module.css";

const GoogleMap = (props) => {
  const { settlementDetails } = props;
  return (
    <div>
      <APIProvider apiKey={AppConstants.GOOGLE_API_KEY} region="au">
        <Map
          zoom={10}
          mapId={"12"}
          center={{ lat: -31.953512, lng: 115.857048 }}
          disableDefaultUI={true}
        >
          {Object?.keys(settlementDetails).map((item, index) => (
            <AdvancedMarker
              id={12}
              key={index}
              position={{
                lat: settlementDetails[item].Lat,
                lng: settlementDetails[item].Long,
              }}
            >
              <div className={rsStyles.mapMarkerIcon}>
                {settlementDetails[item].count}
                <img
                  src={`${AppConstants.WEBAPP_BASE_URL}/src/assets/images/map-marker.png`}
                  alt=""
                />
              </div>
            </AdvancedMarker>
          ))}
        </Map>
      </APIProvider>
    </div>
  );
};

export default GoogleMap;
